function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWinterVacationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.119 17.637h2c0-.84.844-1.521 1.88-1.521 1.039 0 1.883.682 1.883 1.52h2c0-1.94-1.742-3.52-3.882-3.52s-3.881 1.58-3.881 3.52zM26 28h2v-7.363h-2V28zm-12 0h2v-7.364h-2V28zm4 0h6v-7.363h-6V28zm11-9.364H13a1 1 0 00-1 1V29a1 1 0 001 1h16a1 1 0 001-1v-9.364a1 1 0 00-1-1zm-13.554-7.391l-1.81-1.489a1.003 1.003 0 00-1.263-.005l-2.302 1.864L7.9 9.716l4.89-5.243 4.825 5.263-2.17 1.509zm7.716-7.928c-.192-.204-.456-.339-.74-.317a1 1 0 00-.735.331l-3.584 3.978-4.568-4.985A1.065 1.065 0 0012.798 2c-.278 0-.542.115-.732.317l-9.66 10.355 1.463 1.365 2.666-2.858 2.852 2.496a1 1 0 001.288.024l2.322-1.88 1.762 1.452c.345.286.837.303 1.208.049l3.012-2.095.69.753 1.464-1.365L19.46 8.79l2.982-3.311 5.825 6.241 1.463-1.366-6.57-7.037z",
    fill: props.color
  }));
}

export default SvgIconWinterVacationFilled;